import { ModelValidator } from '../../../shared/validation/model-validator';
import { ClientJourneyValidationMetadata } from '../../../shared/validation/client-journey-validation-metadata';
import { Borrower } from '../../../shared/models/deal-resources/borrower.model';
import {
  DateRange,
  IncomeDateRangeValidationService,
} from '../income-daterange-validation.service';

export enum BorrowerIncomeHistoryRules {
  IncomeHistoryPeriod = 'incomeHistoryPeriod',
}

export class BorrowerIncomeHistoryValidator extends ModelValidator<
  Borrower,
  ClientJourneyValidationMetadata
> {
  private readonly _validationPeriodInMonth = 36;

  constructor(borrower: Borrower) {
    super(borrower);

    let navigationMetadata = <ClientJourneyValidationMetadata>{
      blocksNavigation: false,
      showInMenu: true,
    };

    //Income history period
    this.ruleFor(
      borrower => borrower,
      BorrowerIncomeHistoryRules.IncomeHistoryPeriod,
      navigationMetadata,
    ).must(borrower => this.isIncomeHistoryPeriodValid(borrower));
  }

  private isIncomeHistoryPeriodValid(borrower: Borrower): boolean {
    let borrowerIncomeDateRanges =
      this.createBorrowerIncomeDateRanges(borrower);

    const currentDate = new Date();
    const endDate = new Date(currentDate);
    endDate.setMonth(currentDate.getMonth() - this._validationPeriodInMonth);
    const incomeDateRangeValidationService =
      new IncomeDateRangeValidationService(endDate, currentDate);

    let validationResult = incomeDateRangeValidationService.validate(
      borrowerIncomeDateRanges,
    );

    return validationResult;
  }

  private createBorrowerIncomeDateRanges(borrower: Borrower): DateRange[] {
    let incomeDateRanges: DateRange[] = [];
    const currentDate = new Date();

    borrower.employments?.forEach(employment => {
      if (employment.isCurrent && employment.start) {
        incomeDateRanges.push(new DateRange(employment.start, currentDate));
      } else if (employment.start && employment.end) {
        incomeDateRanges.push(new DateRange(employment.start, employment.end));
      }
    });

    borrower.otherIncomes?.forEach(otherIncomes => {
      if (otherIncomes.start) {
        incomeDateRanges.push(new DateRange(otherIncomes.start, currentDate));
      }
    });

    return incomeDateRanges;
  }
}
